import { createApp } from "vue"
import KontactCard from "./ContactCardOnboarding"
import { VueReCaptcha } from 'vue-recaptcha-v3'

const el = ".nyk-component--contact-card-onboarding"

export default function (Store) {
    const DOM = document.querySelectorAll(el)
    if (DOM.length) {
        DOM.forEach((KontactCardDOM) => {
            const recaptchaSiteKey = KontactCardDOM.dataset.recaptchaSiteKey;

            const props = {
                type: KontactCardDOM.dataset.type,
                antiForgeryToken: KontactCardDOM.dataset.antiForgeryToken,
                labels: JSON.parse(KontactCardDOM.dataset.labels),
                categories: KontactCardDOM.dataset.categories ? JSON.parse(KontactCardDOM.dataset.categories) : [],
                wealthCategories: KontactCardDOM.dataset.wealthCategories ? JSON.parse(KontactCardDOM.dataset.wealthCategories) : [],
                formId: KontactCardDOM.dataset.id,
                formGuid: KontactCardDOM.dataset.formGuid,
                formIdentifier: KontactCardDOM.dataset.formId,
                formTypeName: KontactCardDOM.dataset.formTypeName,
                apiUrl: KontactCardDOM.dataset.apiUrl,
                newsletterApiUrl: KontactCardDOM.dataset.newsletterApiUrl,
                newsletters: KontactCardDOM.dataset.newsletters ? JSON.parse(KontactCardDOM.dataset.newsletters) : [],
                alignIntroImageRight: KontactCardDOM.dataset.alignIntroImageRight === "true",
                skipFirstStep: KontactCardDOM.dataset.skipFirstStep === "true",
                imageSource: KontactCardDOM.dataset.imageSource,
                backgroundColor: KontactCardDOM.dataset.backgroundColor ?? null,
                assignTo: KontactCardDOM.dataset.assignTo,
                enableUserTrack: KontactCardDOM.dataset.enableUserTrack === "true",
                redirectUrl: KontactCardDOM.dataset.redirectUrl,
                alwaysShowCprField: KontactCardDOM.dataset.alwaysShowCpr === "true",
                alwaysShowPostalCodeField: KontactCardDOM.dataset.alwaysShowPostalCodeField === "true",
                makeCommentsMandatory: KontactCardDOM.dataset.makeCommentsMandatory === "true"

            }
            const component = createApp(KontactCard, props)
                .use(Store)
                .use(VueReCaptcha, { siteKey: recaptchaSiteKey })
            component.mount(KontactCardDOM)
        })
    }
}
